export class UserInfo {
    id: number;
    firstname: string = '';
    middlename: string = '';
    lastname: string = '';
    profile_picture: string = '';
    profile_picture_temp_url: string = '';
    job_description:number = 0;
    theme_mode:string = '';
    email:string = '';
    department:Array<any> = [];
    branch:Array<any> = [];
    mfa_type:string = '';
    enable_2fa:string='';
    mobile_number:string=''
    masked_mobile_number:string=''
    constructor(obj:UserInfo){
        this.id = obj.id;
        this.firstname = obj.firstname;
        this.middlename = obj.middlename;
        this.lastname = obj.lastname;
        this.profile_picture = obj.profile_picture;
        this.profile_picture_temp_url=obj.profile_picture_temp_url;
        this.job_description = obj.job_description;
        this.theme_mode = obj.theme_mode;
        this.email = obj.email;
        this.department = obj.department;
        this.branch = obj.branch;
        this.mfa_type = obj.mfa_type;
        this.enable_2fa = obj.enable_2fa;
        this.mobile_number = obj.mobile_number;
        this.masked_mobile_number = obj.masked_mobile_number;
    }
}
